"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const classnames_1 = __importDefault(require("classnames"));
const uuid_1 = require("uuid");
const react_router_1 = require("react-router");
const mui_1 = require("tss-react/mui");
const immutable_1 = require("immutable");
const react_use_1 = require("react-use");
const List_1 = __importDefault(require("@mui/material/List"));
const Paper_1 = __importDefault(require("@mui/material/Paper"));
const Divider_1 = __importDefault(require("@mui/material/Divider"));
const ListItem_1 = __importDefault(require("@mui/material/ListItem"));
const TextField_1 = __importDefault(require("@mui/material/TextField"));
const Typography_1 = __importDefault(require("@mui/material/Typography"));
const ButtonBase_1 = __importDefault(require("@mui/material/ButtonBase"));
const ListItemIcon_1 = __importDefault(require("@mui/material/ListItemIcon"));
const ListItemText_1 = __importDefault(require("@mui/material/ListItemText"));
const FormControlLabel_1 = __importDefault(require("@mui/material/FormControlLabel"));
const InputAdornment_1 = __importDefault(require("@mui/material/InputAdornment"));
const LinkRounded_1 = __importDefault(require("@mui/icons-material/LinkRounded"));
const RepeatRounded_1 = __importDefault(require("@mui/icons-material/RepeatRounded"));
const ReplyRounded_1 = __importDefault(require("@mui/icons-material/ReplyRounded"));
const LinkOffRounded_1 = __importDefault(require("@mui/icons-material/LinkOffRounded"));
const LocalOfferRounded_1 = __importDefault(require("@mui/icons-material/LocalOfferRounded"));
const AssignmentRounded_1 = __importDefault(require("@mui/icons-material/AssignmentRounded"));
const NavigateNextRounded_1 = __importDefault(require("@mui/icons-material/NavigateNextRounded"));
const DeleteForeverRounded_1 = __importDefault(require("@mui/icons-material/DeleteForeverRounded"));
const core_1 = require("companion-app-components/utils/core");
const transactions_1 = require("companion-app-components/flux/transactions");
const scheduled_transactions_1 = require("companion-app-components/flux/scheduled-transactions");
const accountGroupsSelectors_1 = require("companion-app-components/flux/account-groups/accountGroupsSelectors");
const feature_flags_1 = require("companion-app-components/flux/feature-flags");
const QPopper_1 = __importDefault(require("components/QPopper"));
const QSwitch_1 = __importDefault(require("components/QSwitch"));
const UIState_1 = __importDefault(require("components/UIState"));
const useQDialogs_1 = __importDefault(require("components/QDialogs/useQDialogs"));
const TagsField_1 = __importDefault(require("components/QuickenControls/TagsField"));
const QTypography_1 = __importDefault(require("components/MUIWrappers/QTypography"));
const AddAndBrowseDocuments_1 = __importDefault(require("components/AddAndBrowseDocuments"));
const SelectScheduledTransactionDialog_1 = __importDefault(require("components/Dialogs/SelectScheduledTransactionDialog"));
const CheckOptionPicker_1 = __importDefault(require("components/TransactionRegister/TransactionRow2/components/CheckOptionPicker"));
const transactionsSelectors = __importStar(require("data/transactions/selectors"));
const utils_1 = require("data/transactions/utils");
const compose_1 = __importDefault(require("utils/compose"));
const checknum_details_inline_svg_1 = __importDefault(require("assets/checknum_details.inline.svg"));
const RecurrenceAssigningDialog_1 = __importDefault(require("./RecurrenceAssigningDialog"));
const CreateNewRecurringDialog_1 = __importDefault(require("./CreateNewRecurringDialog"));
const DeleteRecurringDialog_1 = __importDefault(require("./DeleteRecurringDialog"));
const useSelectOrDispatch_1 = require("./useSelectOrDispatch");
const styles_1 = require("./styles");
const log = (0, core_1.getLogger)('component/DetailsPanel/index.tsx');
const useStyles = (0, mui_1.makeStyles)()(styles_1.styles);
const DetailsPanel = (props) => {
    var _a, _b;
    const { classes } = useStyles();
    const { dialogAlert } = (0, useQDialogs_1.default)();
    const [memo, setMemo] = (0, react_1.useState)(props.txForm.memo);
    const [tags, setTags] = (0, react_1.useState)(props.txForm.tags);
    const [check, setCheck] = (0, react_1.useState)(props.txForm.check && props.txForm.check.number);
    const [sizesChanged, setSizesChanged] = (0, react_1.useState)(false);
    const [attachments, setAttachments] = (0, react_1.useState)(props.txForm.attachments);
    const [recurrencePayee, setRecurrencePayee] = (0, react_1.useState)(props.uiState.recurrencePayee);
    const [recurrenceFrequency, setRecurrenceFrequency] = (0, react_1.useState)(props.uiState.recurrenceFrequency);
    const [showSetupRecurrence, setShowSetupRecurrence] = (0, react_1.useState)(false);
    const [showNewRecurrenceProgress, setShowNewRecurrenceProgress] = (0, react_1.useState)(Boolean(props.uiState.newScheduledTransactionClientId));
    const [showDeleteRecurrenceProgress, setShowDeleteRecurrenceProgress] = (0, react_1.useState)(Boolean(props.uiState.deleteScheduledTransactionId));
    const [showUnlinkRecurrence, setShowUnlinkRecurrence] = (0, react_1.useState)(false);
    const [showSelectScheduledTransactionDialog, setShowSelectScheduledTransactionDialog] = (0, react_1.useState)(false);
    const [showAssignRecurrenceProgress, setShowAssignRecurrenceProgress] = (0, react_1.useState)(false);
    const [selectedScheduledTransactionId, setSelectedScheduledTransactionId] = (0, react_1.useState)(undefined);
    const isEntityShareEnableUser = (0, react_redux_1.useSelector)(accountGroupsSelectors_1.isEntityShareUser);
    const showCheckSuggestions = (0, react_redux_1.useSelector)((state) => feature_flags_1.featureFlagsSelectors.getFeatureFlag(state, 'showCheckSuggestions'));
    const setupRecurrenceRef = (0, react_1.useRef)(null);
    const createNewScheduledTxnTimeout = (0, react_1.useRef)(null);
    const isMountedRef = (0, react_1.useRef)(false);
    const openedScheduledEditLightDialogForClientId = (0, react_1.useRef)(undefined);
    const { scheduledTransactionsEnabled, scheduledTransactions, scheduledTransaction, scheduledTransactionsError, transactionsError, transactionDetailsComprehensive, showTxnJson, coaBucket, txnsByAccountId, accountIds, dispatchDeleteScheduledTransactionAction, dispatchCreateBillScoutScheduleAction, dispatchPerformTransactionAction, dispatchScheduledEditLightDialog, } = (0, useSelectOrDispatch_1.useSelectOrDispatch)(props);
    const prevTnxForm = (0, react_1.useRef)(props.txForm);
    const prevScheduledTransactionsError = (0, react_use_1.usePrevious)(scheduledTransactionsError);
    const prevTransactionsError = (0, react_use_1.usePrevious)(transactionsError);
    const setInitialFocus = () => {
        const node = document.querySelectorAll('[name="details-field-notes"]');
        if (node && node.length > 0) {
            // @ts-expect-error: Property 'focus' does not exist on type 'Element'.
            node[0].focus();
        }
        else {
            setTimeout(() => setInitialFocus(), 100);
        }
    };
    (0, react_use_1.useMount)(() => {
        isMountedRef.current = true;
        setInitialFocus();
        return () => {
            isMountedRef.current = false;
        };
    });
    (0, react_1.useEffect)(() => {
        if ((prevTnxForm === null || prevTnxForm === void 0 ? void 0 : prevTnxForm.current.id) !== props.txForm.id) {
            setMemo(props.txForm.memo);
            setTags(props.txForm.tags);
            setCheck(props.txForm.check && props.txForm.check.number);
            setSizesChanged(false);
            setAttachments(props.txForm.attachments);
            setShowNewRecurrenceProgress(Boolean(props.uiState.newScheduledTransactionClientId));
            setShowDeleteRecurrenceProgress(Boolean(props.uiState.deleteScheduledTransactionId));
            setRecurrencePayee(props.uiState.recurrencePayee);
            setRecurrenceFrequency(props.uiState.recurrenceFrequency);
            prevTnxForm.current = props.txForm;
        }
    }, [prevTnxForm, props]);
    (0, react_1.useEffect)(() => {
        var _a;
        if ((prevTnxForm === null || prevTnxForm === void 0 ? void 0 : prevTnxForm.current.id) !== props.txForm.id) {
            return;
        }
        const changedProps = (0, utils_1.getTxnDifferences)(prevTnxForm === null || prevTnxForm === void 0 ? void 0 : prevTnxForm.current, props.txForm);
        if (changedProps.includes('memo')) {
            setMemo(props.txForm.memo);
        }
        if (changedProps.includes('tags')) {
            setTags(props.txForm.tags);
        }
        if (changedProps.includes('check')) {
            setCheck((_a = props.txForm.check) === null || _a === void 0 ? void 0 : _a.number);
        }
        prevTnxForm.current = props.txForm;
    }, [props, prevTnxForm]);
    (0, react_1.useEffect)(() => {
        var _a;
        if (sizesChanged) {
            setSizesChanged(false);
            (_a = props.onSizeChange) === null || _a === void 0 ? void 0 : _a.call(props);
        }
        if (showNewRecurrenceProgress) {
            if ((scheduledTransaction === null || scheduledTransaction === void 0 ? void 0 : scheduledTransaction.id) && props.uiState.newScheduledTransactionClientId
                && props.uiState.newScheduledTransactionClientId === scheduledTransaction.clientId
                && props.txForm.stModelId === scheduledTransaction.id) {
                if (openedScheduledEditLightDialogForClientId.current !== props.uiState.newScheduledTransactionClientId) {
                    openedScheduledEditLightDialogForClientId.current = props.uiState.newScheduledTransactionClientId;
                    dispatchScheduledEditLightDialog(scheduledTransaction);
                }
                setShowNewRecurrenceProgress(false);
                props.setUIState({ newScheduledTransactionClientId: undefined });
            }
            else if (!prevScheduledTransactionsError && scheduledTransactionsError) {
                setShowNewRecurrenceProgress(false);
                props.setUIState({ newScheduledTransactionClientId: undefined });
                dialogAlert('Sorry', "Can't create recurrence. Try again later.", undefined, ['ok']);
            }
        }
        if (showAssignRecurrenceProgress
            && ((!prevTransactionsError && transactionsError)
                || (props.txForm.stModelId && props.txForm.stModelId === selectedScheduledTransactionId))) {
            setShowAssignRecurrenceProgress(false);
            setSelectedScheduledTransactionId(undefined);
        }
        if (showDeleteRecurrenceProgress
            && ((!prevScheduledTransactionsError && scheduledTransactionsError)
                || !props.txForm.stModelId)) {
            setShowDeleteRecurrenceProgress(false);
            props.setUIState({
                deleteScheduledTransactionId: undefined,
                recurrencePayee: undefined,
                recurrenceFrequency: undefined,
            });
        }
    }, [props, scheduledTransactionsError, prevScheduledTransactionsError,
        scheduledTransaction, showNewRecurrenceProgress, sizesChanged,
        showAssignRecurrenceProgress, prevTransactionsError, transactionsError,
        selectedScheduledTransactionId, showDeleteRecurrenceProgress, dialogAlert,
        dispatchScheduledEditLightDialog,
    ]);
    (0, react_use_1.useUnmount)(() => {
        isMountedRef.current = false;
        if (createNewScheduledTxnTimeout.current) {
            clearTimeout(createNewScheduledTxnTimeout.current);
            createNewScheduledTxnTimeout.current = null;
        }
    });
    const hasFoundMatchingTransfer = (0, react_1.useMemo)(() => {
        var _a;
        if (transactions_1.transactionsUtils.isSplitTxn(props.txForm)) {
            return true;
        }
        const txns = txnsByAccountId.get((_a = props.txForm.coa) === null || _a === void 0 ? void 0 : _a.id);
        return Boolean(transactions_1.transactionsUtils.findMatchingTransferTx(props.txForm, txns));
    }, [props.txForm, txnsByAccountId]);
    let lastTab = 'addDoc';
    if (props.txForm.cpData) {
        lastTab = ((0, utils_1.getMatchState)(props.txForm) === 'matched' && props.unMatchAction) ? 'unmatch' : 'addDoc';
    }
    if ((0, utils_1.isSupportedTransferTxn)(props.txForm) && props.goToTransferAction) {
        lastTab = 'transfer';
    }
    const showSwitchProgress = showSetupRecurrence || showUnlinkRecurrence || showSelectScheduledTransactionDialog
        || showNewRecurrenceProgress || showAssignRecurrenceProgress || showDeleteRecurrenceProgress;
    const callOnChange = (updatedValues, forceSave = false) => {
        if (props.onChange) {
            props.onChange(Object.assign({ memo,
                tags,
                sizesChanged,
                attachments, isBill: props.txForm.isBill, showNewRecurrenceProgress,
                showDeleteRecurrenceProgress,
                recurrencePayee,
                recurrenceFrequency, check: { number: check } }, updatedValues), forceSave);
        }
    };
    const handleChange = (e, field) => {
        let fieldValue = e.target.value;
        if (field === 'memo') {
            setMemo(fieldValue);
        }
        else if (field === 'check') {
            if (fieldValue === null) {
                fieldValue = '';
            }
            setCheck(fieldValue);
        }
        callOnChange({
            memo: field === 'memo' ? fieldValue : memo,
            check: { number: field === 'check' ? fieldValue : check },
        });
    };
    const onFocus = (e) => {
        e.target.select();
    };
    const tagsChange = (tagSet) => {
        log.log('TAG CHANGE RECEIVED ', tagSet);
        setTags(tagSet);
        setSizesChanged(true);
        callOnChange({
            tags: tagSet,
            sizesChanged: true,
        });
    };
    const getRecurrenceLabel = () => {
        let recurrenceLabel;
        switch (coaBucket) {
            case transactionsSelectors.TransactionBucketEnum.EXPENSE:
                recurrenceLabel = props.txForm.stModelId ? 'Is recurring bill' : 'Is a bill';
                break;
            case transactionsSelectors.TransactionBucketEnum.INCOME:
                recurrenceLabel = 'Is recurring income';
                break;
            case transactionsSelectors.TransactionBucketEnum.TRANSFER:
                recurrenceLabel = 'Is recurring transfer';
                break;
            default:
                log.warn('Unexpected coa bucket = ', coaBucket);
                break;
        }
        return recurrenceLabel;
    };
    const createNewScheduledTransaction = () => {
        if (props.txForm.payee) {
            const newScheduledTransactionClientId = (0, uuid_1.v4)().toUpperCase();
            openedScheduledEditLightDialogForClientId.current = undefined;
            props.setUIState({ newScheduledTransactionClientId });
            dispatchCreateBillScoutScheduleAction({
                clientId: newScheduledTransactionClientId,
                id: props.txForm.id,
            });
            setShowNewRecurrenceProgress(true);
            createNewScheduledTxnTimeout.current = setTimeout(() => {
                if (showNewRecurrenceProgress && newScheduledTransactionClientId === props.uiState.newScheduledTransactionClientId) {
                    props.setUIState({ newScheduledTransactionClientId: undefined });
                    if (showNewRecurrenceProgress) {
                        setShowNewRecurrenceProgress(false);
                    }
                    dialogAlert('Sorry', "Can't create recurrence timeout. Try again later.", undefined, ['ok']);
                }
            }, 12000);
        }
        else {
            setShowNewRecurrenceProgress(true);
            dialogAlert('Sorry', 'Without payee name scheduled transactions cannot be created', () => {
                setShowNewRecurrenceProgress(false);
            }, ['ok']);
        }
    };
    const deleteScheduledTransaction = () => {
        var _a;
        if (assert(scheduledTransaction === null || scheduledTransaction === void 0 ? void 0 : scheduledTransaction.id, 'no scheduled transaction model id', scheduledTransaction === null || scheduledTransaction === void 0 ? void 0 : scheduledTransaction.id)) {
            const recurrencePayeeClone = (_a = scheduledTransaction === null || scheduledTransaction === void 0 ? void 0 : scheduledTransaction.transaction) === null || _a === void 0 ? void 0 : _a.payee;
            const recurrenceFrequencyClone = scheduled_transactions_1.scheduledTransactionsUtils.frequencyAliasFromRecurrence(scheduledTransaction === null || scheduledTransaction === void 0 ? void 0 : scheduledTransaction.recurrence);
            props.setUIState({
                deleteScheduledTransactionId: scheduledTransaction === null || scheduledTransaction === void 0 ? void 0 : scheduledTransaction.id,
                recurrencePayee: recurrencePayeeClone,
                recurrenceFrequency: recurrenceFrequencyClone,
            });
            dispatchDeleteScheduledTransactionAction({ id: scheduledTransaction === null || scheduledTransaction === void 0 ? void 0 : scheduledTransaction.id, isDeleted: true });
            setRecurrencePayee(recurrencePayeeClone);
            setRecurrenceFrequency(recurrenceFrequencyClone);
            setShowDeleteRecurrenceProgress(true);
            setTimeout(() => {
                if (showDeleteRecurrenceProgress
                    && (scheduledTransaction === null || scheduledTransaction === void 0 ? void 0 : scheduledTransaction.id) === props.uiState.deleteScheduledTransactionId) {
                    props.setUIState({
                        recurrencePayee: undefined,
                        recurrenceFrequency: undefined,
                    });
                    if (isMountedRef.current) {
                        setShowDeleteRecurrenceProgress(false);
                    }
                    dialogAlert('Sorry', "Can't delete recurrence. Try again later.", undefined, ['ok']);
                }
            }, 8000);
        }
    };
    const getNewRecurrenceLabel = () => {
        let newRecurrenceLabel;
        switch (coaBucket) {
            case transactionsSelectors.TransactionBucketEnum.EXPENSE:
                newRecurrenceLabel = 'New recurring bill';
                break;
            case transactionsSelectors.TransactionBucketEnum.INCOME:
                newRecurrenceLabel = 'New recurring income';
                break;
            case transactionsSelectors.TransactionBucketEnum.TRANSFER:
                newRecurrenceLabel = 'New recurring transfer';
                break;
            default:
                log.warn('Unexpected coa bucket = ', coaBucket);
                break;
        }
        return newRecurrenceLabel;
    };
    const getAssignRecurrenceLabel = () => {
        let assignRecurrenceLabel;
        switch (coaBucket) {
            case transactionsSelectors.TransactionBucketEnum.EXPENSE:
                assignRecurrenceLabel = 'Assign to existing bill';
                break;
            case transactionsSelectors.TransactionBucketEnum.INCOME:
                assignRecurrenceLabel = 'Assign to existing income';
                break;
            case transactionsSelectors.TransactionBucketEnum.TRANSFER:
                assignRecurrenceLabel = 'Assign to existing transfer';
                break;
            default:
                log.warn('Unexpected coa bucket = ', coaBucket);
                break;
        }
        return assignRecurrenceLabel;
    };
    const getDeleteRecurrenceLabel = () => {
        let newRecurrenceLabel;
        switch (coaBucket) {
            case transactionsSelectors.TransactionBucketEnum.EXPENSE:
                newRecurrenceLabel = 'Delete recurring bill';
                break;
            case transactionsSelectors.TransactionBucketEnum.INCOME:
                newRecurrenceLabel = 'Delete recurring income';
                break;
            case transactionsSelectors.TransactionBucketEnum.TRANSFER:
                newRecurrenceLabel = 'Delete recurring transfer';
                break;
            default:
                log.warn('Unexpected coa bucket = ', coaBucket);
                break;
        }
        return newRecurrenceLabel;
    };
    const linkToScheduledTransaction = (selectedScheduledTransaction) => {
        if (assert(props.txForm.id && selectedScheduledTransaction.id, 'transaction id=%s or scheduled transaction id=%s missing', props.txForm.id, selectedScheduledTransaction.id)) {
            setShowSelectScheduledTransactionDialog(false);
            setShowAssignRecurrenceProgress(true);
            setSelectedScheduledTransactionId(selectedScheduledTransaction.id);
            setRecurrencePayee(selectedScheduledTransaction.transaction.payee);
            setRecurrenceFrequency(scheduled_transactions_1.scheduledTransactionsUtils.frequencyAliasFromRecurrence(selectedScheduledTransaction.recurrence));
            dispatchPerformTransactionAction({ action: 'link-to-scheduled-txn', id: props.txForm.id, otherId: selectedScheduledTransaction.id }, { undo: { userMessage: 'Transaction linked.' } });
            setTimeout(() => {
                if (showAssignRecurrenceProgress && selectedScheduledTransaction.id === selectedScheduledTransactionId) {
                    if (isMountedRef.current) {
                        setShowAssignRecurrenceProgress(false);
                    }
                    dialogAlert('Sorry', "Can't link to recurrence. Try again later.", undefined, ['ok']);
                }
            }, 8000);
        }
    };
    const documentsChange = (assets, forceSave) => {
        log.log('SAVING ATTACHMENTS ');
        setAttachments(assets);
        setSizesChanged(true);
        setTimeout(() => {
            callOnChange({
                attachments: assets,
                sizesChanged: true,
            }, forceSave);
        }, 2000);
    };
    const isPendingTxns = props.txForm.source === transactions_1.transactionsTypes.TransactionSource.ScheduledTransactionPending;
    const isTransferAccountPresent = accountIds.get((_a = props.txForm.coa) === null || _a === void 0 ? void 0 : _a.id);
    return (<Paper_1.default elevation={0} className={classes.detailsContainer}>
      {transactionDetailsComprehensive &&
            <div className={classes.webFirstContainer}>
          {/* **** MEMO/NOTES FIELD **** */}
          <div className={classes.detailsRow}>
            <div className={classes.rowIcon}>
              <AssignmentRounded_1.default fontSize="small"/>
            </div>
            <div className={classes.fieldContainer}>
              <TextField_1.default id="details-notes-field" className={classes.textField} sx={{ mt: 4 }} autoFocus onChange={(e) => handleChange(e, 'memo')} placeholder="Memo" value={memo || ''} inputProps={{ onFocus, name: props.firstTabName }} disabled={!props.editable}/>
            </div>
          </div>

          {/* **** TAGS FIELD (when no splits) **** */}
          {!transactions_1.transactionsUtils.isSplitTxn(props.txForm) &&
                    <div className={classes.detailsRow}>
            <div className={classes.rowIcon}>
              <LocalOfferRounded_1.default fontSize="small"/>
            </div>
            <div className={(0, classnames_1.default)(classes.fieldContainer, classes.tagsFieldContainer)}>
              <TagsField_1.default className={classes.textField} value={tags} onChange={tagsChange} id="details-tags-field" editable={props.editable}/>
            </div>
          </div>}

          {/* **** CHECK NUMBER FIELD **** */}
          <div className={(0, classnames_1.default)(classes.detailsRow, classes.checkRow)}>
            <div className={classes.rowIcon}>
              <checknum_details_inline_svg_1.default className={classes.checkNumber}/>
            </div>
            <div className={classes.fieldContainer}>
              <TextField_1.default id="details-check-field" className={classes.textField} onChange={(e) => handleChange(e, 'check')} placeholder="Check Number" value={check || ''} InputProps={{
                    onFocus,
                    endAdornment: showCheckSuggestions ?
                        <InputAdornment_1.default position="end">
                      <CheckOptionPicker_1.default disabled={!props.editable} onSelect={(selectedLabel) => handleChange({ target: { value: selectedLabel } }, 'check')}/>
                    </InputAdornment_1.default> : null,
                }} disabled={!props.editable} autoComplete="off"/>
            </div>
          </div>
        </div>}

      {/* **** BILL SWITCH FIELD **** */}
      {scheduledTransactionsEnabled && (0, utils_1.isExistingTxn)(props.txForm) && !isEntityShareEnableUser &&
            <div className={classes.group}>
        <div className={classes.contentRow}>

          {scheduledTransaction && scheduledTransaction.id ?
                    <react_router_1.Link to={`/bills-and-income?selectNode=${scheduledTransaction && scheduledTransaction.id}`} className={classes.linkStyle}>
              <QTypography_1.default variant="body1">
                {getRecurrenceLabel()}
              </QTypography_1.default>
            </react_router_1.Link>
                    :
                        <QTypography_1.default variant="body1">
              {getRecurrenceLabel()}
            </QTypography_1.default>}

          <FormControlLabel_1.default checked={Boolean(scheduledTransaction)} labelPlacement="start" control={<QSwitch_1.default id="is-recurring-toggle" color="primary" ref={setupRecurrenceRef} showCheckProgress={showSwitchProgress} showUncheckProgress={showSwitchProgress}/>} label="" onChange={(event) => {
                    // @ts-expect-error: Property 'checked' does not exist on type 'EventTarget'.
                    if (event.target.checked) {
                        createNewScheduledTransaction();
                    }
                    else {
                        deleteScheduledTransaction();
                    }
                }}/>
        </div>

        <QPopper_1.default anchorEl={setupRecurrenceRef.current} open={showSetupRecurrence} onClickAway={() => setShowSetupRecurrence((false))} placement="bottom-start" className={classes.recurringMenuPaper}>
          <List_1.default component="nav" aria-label="setup recurring options" className={classes.billMenu}>
            <ListItem_1.default id="create-new-recurring-button" button onClick={() => {
                    createNewScheduledTransaction();
                    setShowSetupRecurrence((false));
                }} className={classes.billMenuItem}>
              <ListItemIcon_1.default>
                <RepeatRounded_1.default />
              </ListItemIcon_1.default>
              <ListItemText_1.default primary={getNewRecurrenceLabel()}/>
            </ListItem_1.default>

            {scheduledTransactions && scheduledTransactions.size > 0 &&
                    <>
              <Divider_1.default />

              <ListItem_1.default id="assign-to-existing-button" button onClick={() => {
                            setShowSetupRecurrence(false);
                            setShowSelectScheduledTransactionDialog(true);
                        }} className={classes.billMenuItem}>
                <ListItemIcon_1.default>
                  <LinkRounded_1.default />
                </ListItemIcon_1.default>
                <ListItemText_1.default primary={getAssignRecurrenceLabel()}/>
                <NavigateNextRounded_1.default />
              </ListItem_1.default>
            </>}

          </List_1.default>
        </QPopper_1.default>

        {/* create new recurrence dialog */}
        <CreateNewRecurringDialog_1.default showNewRecurrenceProgress={showNewRecurrenceProgress} uiState={props.uiState} txForm={props.txForm}/>

        <QPopper_1.default anchorEl={setupRecurrenceRef.current} open={showUnlinkRecurrence} onClickAway={() => setShowUnlinkRecurrence(false)} placement="bottom-start">
          <List_1.default component="nav" aria-label="unlink recurring options" sx={{ p: 0 }}>
            <ListItem_1.default id="remove-from-transaction-button" style={{ display: isPendingTxns ? 'none' : undefined }} button disabled={!showUnlinkRecurrence} onClick={() => {
                    if (assert(props.txForm.id, 'remove from recurrence: no transaction id')) {
                        dispatchPerformTransactionAction({ action: 'unlink-to-scheduled-txn', id: props.txForm.id }, { undo: { userMessage: 'Transaction unlinked.' } });
                        setShowUnlinkRecurrence(false);
                        setSelectedScheduledTransactionId(undefined);
                    }
                }}>
              <ListItemIcon_1.default>
                <LinkOffRounded_1.default />
              </ListItemIcon_1.default>
              <ListItemText_1.default primary="Unlink from recurring series"/>
            </ListItem_1.default>

            <Divider_1.default style={{ display: isPendingTxns ? 'none' : undefined }}/>

            <ListItem_1.default id="delete-recurring-transaction-button" button onClick={() => {
                    deleteScheduledTransaction();
                    setShowUnlinkRecurrence(false);
                }}>
              <ListItemIcon_1.default>
                <DeleteForeverRounded_1.default />
              </ListItemIcon_1.default>
              <ListItemText_1.default primary={getDeleteRecurrenceLabel()}/>
            </ListItem_1.default>
          </List_1.default>
        </QPopper_1.default>

        <SelectScheduledTransactionDialog_1.default open={showSelectScheduledTransactionDialog} onClose={() => setShowSelectScheduledTransactionDialog(false)} onSelected={linkToScheduledTransaction} maxWidth="md" classes={{ paper: classes.dialogPaper }}/>

        {/* Recurrence Assigning dialog */}
        <RecurrenceAssigningDialog_1.default showAssignRecurrenceProgress={showAssignRecurrenceProgress} txForm={props.txForm} recurrencePayee={recurrencePayee} recurrenceFrequency={recurrenceFrequency}/>

        {/* Delete dialog */}
        <DeleteRecurringDialog_1.default showDeleteRecurrenceProgress={showDeleteRecurrenceProgress} recurrencePayee={recurrencePayee} recurrenceFrequency={recurrenceFrequency}/>

      </div>}

      {/* **** ADD DOCUMENT **** */}
      <AddAndBrowseDocuments_1.default id="attachments-upload-button" txn={Object.assign(Object.assign({}, props.txForm), { attachments })} onChange={documentsChange} onSizeChange={props.onSizeChange} lastTabName={lastTab === 'addDoc' ? props.lastTabName : null}/>
      {/* **** TRANSFER **** */}
      {hasFoundMatchingTransfer && (0, utils_1.isSupportedTransferTxn)(props.txForm) && props.goToTransferAction && isTransferAccountPresent && ((_b = props.txForm) === null || _b === void 0 ? void 0 : _b.id) &&
            <div className={(0, classnames_1.default)(classes.detailsRow, classes.txfrRow)}>
          <div className={classes.rowIcon}>
            <ReplyRounded_1.default fontSize="small"/>
          </div>
          {/* @ts-expect-error: missing props */}
          <ButtonBase_1.default focusRipple label="go to transfer" className={classes.link} onClick={() => props.goToTransferAction && props.goToTransferAction()} name={lastTab === 'transfer' ? props.lastTabName : null}>
            <Typography_1.default className={classes.link}>
              {'Go to the other side of this transfer '}
            </Typography_1.default>
          </ButtonBase_1.default>
        </div>}

      {showTxnJson &&
            <div className={(0, classnames_1.default)(classes.detailsRow, classes.txfrRow)}>
          <div className={classes.rowIcon}>
            <ReplyRounded_1.default fontSize="small"/>
          </div>
          {/* @ts-expect-error: missing props */}
          <ButtonBase_1.default focusRipple label="json view" className={classes.link} onClick={() => dialogAlert('JSON View', JSON.stringify(props.txForm), null, ['Close'], 'info')} name={lastTab === 'transfer' ? props.lastTabName : null}>
            <Typography_1.default className={classes.link}>
              Display Transaction JSON
            </Typography_1.default>
          </ButtonBase_1.default>
        </div>}
    </Paper_1.default>);
};
const DetailsPanelUIState = (0, immutable_1.Record)({
    newScheduledTransactionClientId: undefined,
    deleteScheduledTransactionId: undefined,
    recurrencePayee: undefined,
    recurrenceFrequency: undefined,
});
const uiStateConfig = {
    name: (props) => `DetailsPanel:${props.txForm.id}`,
    state: () => DetailsPanelUIState(),
    persist: true,
};
DetailsPanel.whyDidYouRender = true;
exports.default = (0, compose_1.default)((0, UIState_1.default)(uiStateConfig))(DetailsPanel);
